import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { RestApiService } from '../common-app/service/rest-api.service';
import { Kvaw0520Vo } from './kvaw0520.vo';

/**
 * サーバとの通信を行う。
 * @see WebAPI仕様_KVAW0520（日報情報取得（前回値））.xlsx
 */
@Injectable()
export class Kvaw0520Service {

  /** 検索対象 */
  private static TARGET = 'kvaw0520';

  constructor(
    private restApiService: RestApiService,
  ) { }

  /**
   * 日報詳細情報（前回訪問時の実績情報）を取得する
   *
   * @param storeCode 相手先コード
   */
  searchReportDetailActualLast(storeCode?: string): Observable<Kvaw0520Vo> {
    const query = {
      storeCode: storeCode,
    };

    return this.restApiService.search<Kvaw0520Vo>(Kvaw0520Service.TARGET, query);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/kvaw0520.service.ts